import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Local-storage token + cookie both supported. Cookie is httpOnly so we keep
// a parallel localStorage copy so the SPA can send Authorization header where
// cross-domain cookies might be blocked.
const TOKEN_KEY = "aos_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const adminAxios = axios.create({
  baseURL: API,
  withCredentials: true,
});
adminAxios.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${t}`;
  }
  return cfg;
});

export const adminLogin = async (email, password) => {
  const { data } = await adminAxios.post("/auth/admin/login", { email, password });
  if (data?.token) setToken(data.token);
  return data;
};

export const adminLogout = async () => {
  try {
    await adminAxios.post("/auth/admin/logout");
  } catch (_e) {
    // ignore
  }
  clearToken();
};

export const fetchAdminMe = () => adminAxios.get("/auth/admin/me").then((r) => r.data);
export const fetchRegistrations = () =>
  adminAxios.get("/admin/registrations").then((r) => r.data);
export const fetchLeads = () => adminAxios.get("/admin/leads").then((r) => r.data);
export const fetchAdminStats = () => adminAxios.get("/admin/stats").then((r) => r.data);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
